import React, { useEffect, useState } from "react"
import { apiFetch } from "../utils/apiFetch"
import "../shared/styles/settings-system.css"

export default function TreatmentRulesAdmin() {
  const API_BASE =
  (typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname)
    ? ["http://localhost", "3000/api"].join(":")
    : "/api")
  const [userId] = useState("e922ef71-7119-4f8c-8b73-3c8c42629ebd")

  const [clinics, setClinics] = useState([])
  const [clinicId, setClinicId] = useState("")
  const [treatments, setTreatments] = useState([])
  const [savingId, setSavingId] = useState("")

  const specialties = [
    { value: "", label: "Sin especialidad obligatoria" },
    { value: "GENERAL", label: "General" },
    { value: "ORTODONCIA", label: "Ortodoncia" },
    { value: "ENDODONCIA", label: "Endodoncia" },
    { value: "CIRUGIA", label: "CirugÃ­a" },
    { value: "IMPLANTOLOGIA", label: "ImplantologÃ­a" },
    { value: "PROSTODONCIA", label: "Prostodoncia" },
    { value: "PERIODONCIA", label: "Periodoncia" },
    { value: "PEDIATRIA", label: "OdontopediatrÃ­a" }
  ]

  const loadClinics = async () => {
    try {
      const res = await apiFetch(`${API_BASE}/multi-clinic/user-clinics?userId=${userId}`)
      const data = await res.json().catch(() => [])
      const rows = Array.isArray(data) ? data : []
      setClinics(rows)

      if (!clinicId && rows.length > 0) {
        setClinicId(rows[0].clinicId)
      }
    } catch {
      setClinics([])
    }
  }

  const loadTreatments = async (cId = clinicId) => {
    try {
      if (!cId) return
      const res = await apiFetch(`${API_BASE}/treatments?clinicId=${cId}`)
      const data = await res.json().catch(() => [])
      setTreatments(Array.isArray(data) ? data : [])
    } catch {
      setTreatments([])
    }
  }

  useEffect(() => {
    loadClinics()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!clinicId) return
    loadTreatments(clinicId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinicId])

  const updateTreatmentSpecialtyLocal = (treatmentId, requiredSpecialty) => {
    setTreatments((prev) =>
      prev.map((t) =>
        t.id === treatmentId
          ? { ...t, requiredSpecialty: requiredSpecialty || null }
          : t
      )
    )
  }

  const saveTreatmentRule = async (treatment) => {
    try {
      setSavingId(treatment.id)

      const res = await apiFetch(`${API_BASE}/treatments/required-specialty`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          treatmentId: treatment.id,
          requiredSpecialty: treatment.requiredSpecialty || null
        })
      })

      if (!res.ok) {
        alert("No se pudo guardar la especialidad requerida")
        return
      }

      alert(`Regla guardada para ${treatment.name}`)
    } catch {
      alert("Error al guardar la regla")
    } finally {
      setSavingId("")
    }
  }

  return (
    <div className="of-settings-page">
      <div className="of-settings-hero">
        <h1 className="of-settings-hero__title">Reglas clÃ­nicas de tratamientos</h1>
        <div className="of-settings-hero__subtitle">
          Define si un tratamiento requiere una especialidad especÃ­fica o si puede
          ser realizado sin restricciÃ³n obligatoria.
        </div>
      </div>

      <div className="of-settings-grid">
        <div className="of-settings-card">
          <div className="of-settings-topbar">
            <div>
              <div className="of-settings-card__title">ClÃ­nica activa</div>
              <div className="of-settings-card__subtitle">
                Selecciona la sede para administrar reglas clÃ­nicas.
              </div>
            </div>

            <div style={{ minWidth: 280 }}>
              <select
                value={clinicId}
                onChange={(e) => setClinicId(e.target.value)}
                className="of-settings-select"
              >
                {clinics.map((c) => (
                  <option key={c.id} value={c.clinicId}>
                    {c.clinic?.name || c.clinicName || c.name || "ClÃ­nica"}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="of-settings-card">
          <div className="of-settings-card__title">Especialidad requerida por tratamiento</div>
          <div className="of-settings-card__subtitle">
            Ajusta la lÃ³gica clÃ­nica sin salir del catÃ¡logo operativo.
          </div>

          <div className="of-settings-list">
            {treatments.map((t) => (
              <div key={t.id} className="of-settings-item">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "minmax(0, 1fr) 300px auto",
                    gap: 12,
                    alignItems: "center"
                  }}
                >
                  <div>
                    <div className="of-settings-item__title">{t.name}</div>
                    <div className="of-settings-item__meta">
                      DuraciÃ³n: {t.durationMinutes} min Â· Precio: ${t.price}
                    </div>
                  </div>

                  <select
                    value={t.requiredSpecialty || ""}
                    onChange={(e) =>
                      updateTreatmentSpecialtyLocal(t.id, e.target.value)
                    }
                    className="of-settings-select"
                  >
                    {specialties.map((s) => (
                      <option key={s.value} value={s.value}>
                        {s.label}
                      </option>
                    ))}
                  </select>

                  <button
                    onClick={() => saveTreatmentRule(t)}
                    disabled={savingId === t.id}
                    className="of-settings-button of-settings-button--info"
                  >
                    {savingId === t.id ? "Guardando..." : "Guardar"}
                  </button>
                </div>
              </div>
            ))}

            {!treatments.length && (
              <div className="of-settings-empty">Sin tratamientos disponibles.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
